export default "__VITE_ASSET__CIEcOupR__"